if (!customElements.get('festpakke-upsell')) {
  customElements.define(
    'festpakke-upsell',
    class FestpakkeUpsell extends HTMLElement {
      constructor() {
        super();
        this.suppressCartDrawer = this.dataset.suppressCartDrawer === 'true';
        this.openerElement = null;
        this.pendingCartDrawerOpen = false;
        this.dialog = this.querySelector('.festpakke-upsell__dialog');
        this.addButton = this.querySelector('[data-festpakke-upsell-add]');
        this.titleEl = this.querySelector('[data-festpakke-title]');
        this.imageEl = this.querySelector('[data-festpakke-image]');
        this.priceEl = this.querySelector('[data-festpakke-price]');
        this.compareAtEl = this.querySelector('[data-festpakke-compare-at]');
        this.saveEl = this.querySelector('[data-festpakke-save]');
        this.linkEl = this.querySelector('[data-festpakke-link]');
      }

      connectedCallback() {
        if (this.cartUpdateUnsubscriber) return;
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));

        this.querySelectorAll('[data-festpakke-upsell-dismiss]').forEach((el) => {
          el.addEventListener('click', this.onDismiss.bind(this));
        });
        if (this.addButton) {
          this.addButton.addEventListener('click', this.onAddFestpakke.bind(this));
        }
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.hasAttribute('open')) this.onDismiss();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      onCartUpdate(event) {
        // Kun PC: spring popup + cart-drawer-suppression over på mobil/tablet (<990px).
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        if (!event || event.source !== 'product-form') return;
        if (!event.productVariantId) return;

        const mapping = this.findMappingForVariant(event.productVariantId);
        if (!mapping) return;
        if (!mapping.festpakke_available) return;
        if (event.cartData && event.cartData.product_id === mapping.festpakke_product_id) return;
        // Tilbehørs-checkboxene på produktsiden (product-addons-picker) lægger selv varen
        // i kurven ved submit. Har kunden allerede krydset netop denne af, så lad være med
        // at tilbyde den igen i popup'en.
        if (
          document.querySelector(
            'input[data-product-addon-variant-id="' + mapping.festpakke_variant_id + '"]:checked'
          )
        ) {
          return;
        }

        this.openerElement = document.activeElement;
        this.populate(mapping);
        if (this.suppressCartDrawer) this.suppressDrawer(true);
        this.open();
      }

      findMappingForVariant(variantId) {
        const variantKey = String(variantId);
        const dataNodes = document.querySelectorAll('script.festpakke-upsell-data');
        for (const node of dataNodes) {
          let parsed;
          try {
            parsed = JSON.parse(node.textContent);
          } catch (e) {
            console.warn('[festpakke-upsell] invalid mapping JSON', e);
            continue;
          }
          if (parsed && Object.prototype.hasOwnProperty.call(parsed, variantKey)) {
            return parsed[variantKey];
          }
        }
        return null;
      }

      populate(mapping) {
        this.currentMapping = mapping;
        if (this.titleEl) this.titleEl.textContent = mapping.festpakke_title || '';
        if (this.linkEl) this.linkEl.href = mapping.festpakke_url || '#';
        if (this.imageEl) {
          if (mapping.festpakke_image) {
            this.imageEl.src = mapping.festpakke_image;
            this.imageEl.alt = mapping.festpakke_title || '';
            this.imageEl.hidden = false;
          } else {
            this.imageEl.removeAttribute('src');
            this.imageEl.hidden = true;
          }
        }
        if (this.priceEl) this.priceEl.innerHTML = mapping.festpakke_price_html || '';
        if (this.compareAtEl) {
          if (mapping.festpakke_compare_at_html) {
            this.compareAtEl.innerHTML = mapping.festpakke_compare_at_html;
            this.compareAtEl.hidden = false;
          } else {
            this.compareAtEl.innerHTML = '';
            this.compareAtEl.hidden = true;
          }
        }
        if (this.saveEl) {
          if (mapping.festpakke_save_html) {
            this.saveEl.textContent = `Spar ${mapping.festpakke_save_html}`;
            this.saveEl.hidden = false;
          } else {
            this.saveEl.textContent = '';
            this.saveEl.hidden = true;
          }
        }
        if (this.addButton) {
          this.addButton.disabled = false;
          this.addButton.classList.remove('loading');
          const spinner = this.addButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      }

      open() {
        this.hidden = false;
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        requestAnimationFrame(() => {
          if (this.dialog && typeof this.dialog.focus === 'function') this.dialog.focus();
        });
      }

      close() {
        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        this.hidden = true;
        document.body.classList.remove('overflow-hidden');
        if (this.openerElement && typeof this.openerElement.focus === 'function') {
          this.openerElement.focus();
        }
      }

      onDismiss(event) {
        if (event) event.preventDefault();
        this.close();
        if (this.suppressCartDrawer) {
          this.suppressDrawer(false);
          this.openCartDrawer();
        }
      }

      onAddFestpakke(event) {
        if (event) event.preventDefault();
        if (!this.currentMapping || !this.currentMapping.festpakke_variant_id) return;

        this.addButton.disabled = true;
        this.addButton.classList.add('loading');
        const spinner = this.addButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
          ? cartDrawer.getSectionsToRender().map((s) => s.id)
          : [];

        const body = JSON.stringify({
          items: [{ id: this.currentMapping.festpakke_variant_id, quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        });

        const config = fetchConfig();
        config.body = body;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('[festpakke-upsell] cart/add error', response);
              this.close();
              if (this.suppressCartDrawer) {
                this.suppressDrawer(false);
                this.openCartDrawer();
              }
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'festpakke-upsell',
              productVariantId: this.currentMapping.festpakke_variant_id,
              cartData: response,
            });

            this.close();
            if (this.suppressCartDrawer) {
              this.suppressDrawer(false);
              if (cartDrawer && response.sections) {
                cartDrawer.renderContents(response);
              } else {
                this.openCartDrawer();
              }
            }
          })
          .catch((err) => {
            console.error('[festpakke-upsell] fetch error', err);
            this.close();
            if (this.suppressCartDrawer) {
              this.suppressDrawer(false);
              this.openCartDrawer();
            }
          })
          .finally(() => {
            this.addButton.disabled = false;
            this.addButton.classList.remove('loading');
            const sp = this.addButton.querySelector('.loading__spinner');
            if (sp) sp.classList.add('hidden');
          });
      }

      suppressDrawer(suppress) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        if (suppress) {
          cartDrawer.dataset.suppressOpen = 'true';
        } else {
          delete cartDrawer.dataset.suppressOpen;
        }
      }

      openCartDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }
    }
  );
}
